import { render, staticRenderFns } from "./category-navbar.vue?vue&type=template&id=6fa90517&scoped=true"
import script from "./category-navbar.vue?vue&type=script&lang=js"
export * from "./category-navbar.vue?vue&type=script&lang=js"
import style0 from "./category-navbar.vue?vue&type=style&index=0&id=6fa90517&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa90517",
  null
  
)

export default component.exports